export const copyMerchantModalTheme = {
  copyRelated: 'palette.tertiary.50',
  section: {
    bg: 'palette.surface.4',
    borderColor: 'palette.tertiary.5',
    borderRadius: '12px',
    borderWidth: '1px',
  },
  subtitleEnd: 'palette.tertiary.50',
};
